"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountableTotal = void 0;
var es_toolkit_1 = require("es-toolkit");
var react_1 = __importDefault(require("react"));
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var QuoteSummaryContextProvider_1 = require("./QuoteSummaryContextProvider");
var styles = __importStar(require("./QuoteSummaryWidget.css"));
var hasDiscount = function (discount) {
    if (discount && discount.enabled) {
        return !(0, es_toolkit_1.isNil)(discount.units) && discount.units !== 0;
    }
    return false;
};
var DiscountableTotal = function (_a) {
    var _b;
    var preTax = _a.preTax, preDiscount = _a.preDiscount, frequencyLabel = _a.frequencyLabel, labelSetId = _a.labelSetId, discount = _a.discount;
    var _c = (0, QuoteSummaryContextProvider_1.useQuoteSummaryContext)(), formatCurrency = _c.formatCurrency, getLabel = _c.getLabel;
    var isDiscounted = hasDiscount(discount);
    var discountUnits = discount !== null
        ? discount.type === Types_1.DiscountType.Fixed
            ? "".concat(formatCurrency((_b = discount.units) !== null && _b !== void 0 ? _b : 0))
            : "".concat(discount.units, "%")
        : "";
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", { className: styles.subTotalItem }, "".concat(formatCurrency(preTax)).concat(!!frequencyLabel ? " / ".concat(frequencyLabel) : "")),
        isDiscounted && (react_1.default.createElement("p", { className: styles.discountText },
            react_1.default.createElement("span", { className: styles.preDiscountValue, "aria-label": "Price before discount" }, "".concat(formatCurrency(preDiscount))), " ".concat(discountUnits, " ").concat(getLabel(labelSetId, Types_1.QuoteLabel.PercentageOff))))));
};
exports.DiscountableTotal = DiscountableTotal;
